export var STUDY_PLAN_METRICS_TRANSLATION_KEY = 'study-plan-metrics';